module.exports = __webpack_public_path__ + "static/media/arrow-right.e2681023.svg";